export default __webpack_public_path__ + "static/media/image.60-international.0033717f.png";